import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';
import type { OrganizationSchedulingSettings } from '../../api/queries';

export const GET_ORGANIZATION_SCHEDULING_SETTINGS_QUERY_KEY =
  'GET_ORGANIZATION_SCHEDULING_SETTINGS';

export const useGetOrganizationSchedulingSettings = () => {
  const { getCurrentOrganizationSchedulingSettings } = useServicesContext();

  return useQuery<OrganizationSchedulingSettings | null>({
    queryKey: [GET_ORGANIZATION_SCHEDULING_SETTINGS_QUERY_KEY],
    queryFn: () => getCurrentOrganizationSchedulingSettings(),
  });
};
